<template>
  <b-notification class="is-danger" :active.sync="isNotificationActive">
    {{ message }}
  </b-notification>
</template>

<script>
export default {
  props: ["active", "message"],
  computed: {
    isNotificationActive: {
      get: function() {
        return this.active;
      },
      set: function() {}
    }
  }
};
</script>
